module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.4a1d8c2.eot";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/Roboto-Bold/Roboto-Bold.eot
// module id = i320
// module chunks = 17